import codReportService from "src/services/codReportService";

export const GET_REPORT_COD_REQUEST = "@cod/cod-report-request";
export const GET_REPORT_COD_SUCCESS = "@cod/cod-report-success";
export const GET_REPORT_COD_FAILURE = "@cod/cod-report-failure";

export function getListCodReport(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_REPORT_COD_REQUEST});
      const response = await codReportService.getListCodReport(params);
      dispatch({
        type: GET_REPORT_COD_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_REPORT_COD_FAILURE});
      throw error;
    }
  };
}
